import type React from "react";

import useImageUtils from "~/hooks/useImageUtils";
import { useRootLayoutData } from "~/root";

import DefaultImage from "./icons/default-image";

interface ImageProps<T extends React.ElementType = "img">
  extends React.ImgHTMLAttributes<HTMLImageElement> {}

const Image: React.FC<ImageProps> = ({ ...props }) => {
  const { getImageLink } = useImageUtils();
  const { IMAGES_HOST } = useRootLayoutData();

  let fullSrc = "";

  if (IMAGES_HOST && props.src) {
    fullSrc = props.src.includes(IMAGES_HOST)
      ? props.src
      : getImageLink(props.src);
  }

  return fullSrc ? (
    // Spread first so the re-hosted `fullSrc` wins: `props` still carries the
    // raw incoming `src`, and if it spreads AFTER it clobbers `fullSrc` back to
    // the un-rehosted link (SFCC-11868 — bundle child thumbnails rendered the
    // raw instance host, which 403s/ORB-blocks).
    // `alt` restated explicitly (though `{...props}` carries it): jsx-a11y/alt-text
    // is spread-blind and errors without a literal `alt` prop.
    <img {...props} src={fullSrc} alt={props.alt} />
  ) : (
    <DefaultImage {...props} />
  );
};

export default Image;
